import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { I18NService } from '../i18n/i18n.service';

@Injectable({
    providedIn: 'root',
})
export class ScrapingService {
    constructor(
        private i18nService: I18NService,
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: object,
    ) {}

    getCityInfo(city, lines) {
        const url = `https://${this.i18nService.currentLang}.wikipedia.org/w/api.php?action=query&prop=extracts&exsentences=${lines}&exlimit=1&titles=${city}&explaintext=1&formatversion=2&format=json`;

        if (isPlatformBrowser(this.platformId)) {
            return this.http.jsonp(url, 'callback');
        } else {
            return this.http.get(url);
        }
    }
}
